angular.module('leanlaw').controller('OriginatingAttorneyCtrl', ['$scope', '$rootScope', '$q', '$filter', '$state', "alerts", 'userService', 'reportsService', 'singleRequest', 'accountingService', "exportJson", "messageBus", function ($scope, $rootScope, $q, $filter, $state, alerts, userService, reportsService, singleRequest, accountingService, exportJson, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'user.name';
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const exp = $scope.data.filtered.reduce((accum, c) => {
      accum.push({
        User: c.user.name,
        "Collected Services": $filter("amount")(c.data.collected.servicesTotal),
        "Collected Expenses": $filter("amount")(c.data.collected.expensesTotal),
        "Collected Total": $filter("amount")(c.data.collected.total)
      });
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.gotoDetail = function (user) {
    $state.go("reports.originating-attorney-detail", {
      id: user.id,
      report: `Originating`,
      return: "reports.originating-attorney"
    });
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      accountingService.verify(false).then(state => {
        $scope.accounting = state.connected;
      }).finally(() => {
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          $scope.filter.startDate = $scope.filter.filter.range.startDate;
          $scope.filter.endDate = $scope.filter.filter.range.endDate;
          $scope.filter.scopeAccount = $scope.filter.filter.scopeAccount ? $scope.filter.filter.scopeAccount.id : null;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
        filterClientEntries();
      });
    });
  }
  function filterClientEntries() {
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "payments";
    query.primary = 'users';
    query.accountFilter = 'originating';
    query.reportType = 'revenue';
    $scope.loading = true;
    singleRequest.serviceCall("report", reportsService.getReport)(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.data = data;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
}]);